<div class="grid-x">
  <div class="cell large-3 medium-4 small-12"><label>Registration URL:</label></div>
  <div class="cell large-9 medium-8 small-12 bold-text"><span [ngClass]="registryURLChange| defineDomainViewCss: '': 'registry'">{{registryURL}}</span></div>
</div>
<div class="grid-x">
  <div class="cell large-3 medium-4 small-12"><label>WHOIS Server:</label></div>
  <div class="cell large-9 medium-8 small-12 bold-text"><span [ngClass]="whoIsChange| defineDomainViewCss: '': 'whois'">{{whois}}</span></div>
</div>
<div class="grid-x">
  <div class="cell large-3 medium-4 small-12"><label>RDAP Servers:</label></div>
  <div class="cell large-9 medium-8 small-12 bold-text">
    <div *ngFor="let rdap of rdapServers"><span
      [ngClass]="rdapServerChange| defineDomainViewCss: rdap: 'rdap'">{{rdap.url}}</span></div>
  </div>
</div>
<div class="grid-x last-update-button-section">
  <label>{{lastchange | lastChange}}</label>
  <button *ngIf="!viewMode" class="iana-button" id="update" [disabled]="!hasTechnicalPermission || !showEdit" (click)="onEdit()">Modify</button>
</div>
